module.exports = __webpack_public_path__ + "static/media/Trn1.f0c3b6c5.svg";